module.exports = __webpack_public_path__ + "img/Microsoft_AZ-900.4ff1b19a.png";